module.exports = __webpack_public_path__ + "img/RO_faucet_IMG_5498-10.a492ff6a.jpg";